








import { Vue, Component, Watch } from "vue-property-decorator";
import { StoreState } from "../../store";
import { mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
@Component({
  components: { ModelListSelect },
  methods: {
    codeAndNameAndDesc(item) {
      //By default
      if (this.$data.stringItem == "") {
        this.$emit(
          "timeZoneChange",
          "-12:00$Etc/GMT+12$International Date Line West"
        );
      } else {
        //on chnge timezone
        this.$emit("timeZoneChange", this.$data.stringItem.value);
      }
      return `${item.text} `;
    }
  }
})
export default class TimeZoneVue extends Vue {
  data() {
    return {
      stringItem: "",
      TimeZones: [
        {
          value: "-12:00$Etc/GMT+12$International Date Line West",
          abbr: "DST",
          offset: -12,
          isdst: false,
          text: "(UTC-12:00) International Date Line West",
          utc: ["Etc/GMT+12"]
        },
        {
          value: "-11:00$Etc/GMT+11$Coordinated Universal Time",
          abbr: "U",
          offset: -11,
          isdst: false,
          text: "(UTC-11:00) Coordinated Universal Time",
          utc: [
            "Etc/GMT+11",
            "Pacific/Midway",
            "Pacific/Niue",
            "Pacific/Pago_Pago"
          ]
        },
        {
          value: "-10:00$Etc/GMT+10$Hawaii",
          abbr: "HST",
          offset: -10,
          isdst: false,
          text: "(UTC-10:00) Hawaii",
          utc: [
            "Etc/GMT+10",
            "Pacific/Honolulu",
            "Pacific/Johnston",
            "Pacific/Rarotonga",
            "Pacific/Tahiti"
          ]
        },
        {
          value: "-08:00$America/Anchorage$Alaska",
          abbr: "AKDT",
          offset: -8,
          isdst: true,
          text: "(UTC-09:00) Alaska",
          utc: [
            "America/Anchorage",
            "America/Juneau",
            "America/Nome",
            "America/Sitka",
            "America/Yakutat"
          ]
        },
        {
          value: "-07:00$America/Santa_Isabel$Baja California",
          abbr: "PDT",
          offset: -7,
          isdst: true,
          text: "(UTC-08:00) Baja California",
          utc: ["America/Santa_Isabel"]
        },
        {
          value: "-07:00$America/Dawson$Pacific Time (US & Canada)",
          abbr: "PDT",
          offset: -7,
          isdst: true,
          text: "(UTC-07:00) Pacific Time (US & Canada)",
          utc: [
            "America/Dawson",
            "America/Los_Angeles",
            "America/Tijuana",
            "America/Vancouver",
            "America/Whitehorse"
          ]
        },

        {
          value: "-07:00$America/Creston$Arizona",
          abbr: "UMST",
          offset: -7,
          isdst: false,
          text: "(UTC-07:00) Arizona",
          utc: [
            "America/Creston",
            "America/Dawson_Creek",
            "America/Hermosillo",
            "America/Phoenix",
            "Etc/GMT+7"
          ]
        },
        {
          value: "-06:00$America/Chihuahua$Chihuahua, La Paz, Mazatlan",
          abbr: "MDT",
          offset: -6,
          isdst: true,
          text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
          utc: ["America/Chihuahua", "America/Mazatlan"]
        },
        {
          value: "-06:00$America/Boise$Mountain Time ",
          abbr: "MDT",
          offset: -6,
          isdst: true,
          text: "(UTC-07:00) Mountain Time (US & Canada)",
          utc: [
            "America/Boise",
            "America/Cambridge_Bay",
            "America/Denver",
            "America/Edmonton",
            "America/Inuvik",
            "America/Ojinaga",
            "America/Yellowknife",
            "MST7MDT"
          ]
        },
        {
          value: "-06:00$America/Belize$Central America",
          abbr: "CAST",
          offset: -6,
          isdst: false,
          text: "(UTC-06:00) Central America",
          utc: [
            "America/Belize",
            "America/Costa_Rica",
            "America/El_Salvador",
            "America/Guatemala",
            "America/Managua",
            "America/Tegucigalpa",
            "Etc/GMT+6",
            "Pacific/Galapagos"
          ]
        },
        {
          value: "-05:00$America/Chicago$Chicago",
          abbr: "CDT",
          offset: -5,
          isdst: true,
          text: "(UTC-06:00) Central Time (US & Canada)",
          utc: [
            "America/Chicago",
            "America/Indiana/Knox",
            "America/Indiana/Tell_City",
            "America/Matamoros",
            "America/Menominee",
            "America/North_Dakota/Beulah",
            "America/North_Dakota/Center",
            "America/North_Dakota/New_Salem",
            "America/Rainy_River",
            "America/Rankin_Inlet",
            "America/Resolute",
            "America/Winnipeg",
            "CST6CDT"
          ]
        },
        {
          value:
            "-05:00$America/Bahia_Banderas$Guadalajara, Mexico City, Monterrey",
          abbr: "CDT",
          offset: -5,
          isdst: true,
          text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
          utc: [
            "America/Bahia_Banderas",
            "America/Cancun",
            "America/Merida",
            "America/Mexico_City",
            "America/Monterrey"
          ]
        },
        {
          value: "-06:00$America/Regina$Saskatchewan",
          abbr: "CCST",
          offset: -6,
          isdst: false,
          text: "(UTC-06:00) Saskatchewan",
          utc: ["America/Regina", "America/Swift_Current"]
        },
        {
          value: "-05:00$America/Bogota$Bogota, Lima, Quito",
          abbr: "SPST",
          offset: -5,
          isdst: false,
          text: "(UTC-05:00) Bogota, Lima, Quito",
          utc: [
            "America/Bogota",
            "America/Cayman",
            "America/Coral_Harbour",
            "America/Eirunepe",
            "America/Guayaquil",
            "America/Jamaica",
            "America/Lima",
            "America/Panama",
            "America/Rio_Branco",
            "Etc/GMT+5"
          ]
        },
        {
          value: "-04:00$America/Detroit$Eastern Time",
          abbr: "EDT",
          offset: -4,
          isdst: true,
          text: "(UTC-05:00) Eastern Time (US & Canada)",
          utc: [
            "America/Detroit",
            "America/Havana",
            "America/Indiana/Petersburg",
            "America/Indiana/Vincennes",
            "America/Indiana/Winamac",
            "America/Iqaluit",
            "America/Kentucky/Monticello",
            "America/Louisville",
            "America/Montreal",
            "America/Nassau",
            "America/New_York",
            "America/Nipigon",
            "America/Pangnirtung",
            "America/Port-au-Prince",
            "America/Thunder_Bay",
            "America/Toronto",
            "EST5EDT"
          ]
        },
        {
          value: "-04:00$America/Indiana/Marengo$Indiana",
          abbr: "UEDT",
          offset: -4,
          isdst: true,
          text: "(UTC-05:00) Indiana (East)",
          utc: [
            "America/Indiana/Marengo",
            "America/Indiana/Vevay",
            "America/Indianapolis"
          ]
        },
        {
          value: "-04:00$America/Caracas$Caracas",
          abbr: "VST",
          offset: -4.0,
          isdst: false,
          text: "(UTC-04:00) Caracas",
          utc: ["America/Caracas"]
        },
        {
          value: "-04:00$America/Asuncion$Asuncion",
          abbr: "PYT",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Asuncion",
          utc: ["America/Asuncion"]
        },
        {
          value: "-03:00$America/Glace_Bay$Atlantic Time",
          abbr: "ADT",
          offset: -3,
          isdst: true,
          text: "(UTC-04:00) Atlantic Time (Canada)",
          utc: [
            "America/Glace_Bay",
            "America/Goose_Bay",
            "America/Halifax",
            "America/Moncton",
            "America/Thule",
            "Atlantic/Bermuda"
          ]
        },
        {
          value: "-04:00$America/Campo_Grande$Cuiaba",
          abbr: "CBST",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Cuiaba",
          utc: ["America/Campo_Grande", "America/Cuiaba"]
        },
        {
          value: "-04:00$America/Anguilla$Georgetown, La Paz, Manaus, San Juan",
          abbr: "SWST",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
          utc: [
            "America/Anguilla",
            "America/Antigua",
            "America/Aruba",
            "America/Barbados",
            "America/Blanc-Sablon",
            "America/Boa_Vista",
            "America/Curacao",
            "America/Dominica",
            "America/Grand_Turk",
            "America/Grenada",
            "America/Guadeloupe",
            "America/Guyana",
            "America/Kralendijk",
            "America/La_Paz",
            "America/Lower_Princes",
            "America/Manaus",
            "America/Marigot",
            "America/Martinique",
            "America/Montserrat",
            "America/Port_of_Spain",
            "America/Porto_Velho",
            "America/Puerto_Rico",
            "America/Santo_Domingo",
            "America/St_Barthelemy",
            "America/St_Kitts",
            "America/St_Lucia",
            "America/St_Thomas",
            "America/St_Vincent",
            "America/Tortola",
            "Etc/GMT+4"
          ]
        },
        {
          value: "-04:00$America/Santiago$Santiago",
          abbr: "PSST",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Santiago",
          utc: ["America/Santiago", "Antarctica/Palmer"]
        },
        {
          value: "-02:30$America/St_Johns$Newfoundland",
          abbr: "NDT",
          offset: -2.5,
          isdst: true,
          text: "(UTC-02:30) Newfoundland",
          utc: ["America/St_Johns"]
        },
        {
          value: "-03:00$America/Sao_Paulo$Brasilia",
          abbr: "ESAST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Brasilia",
          utc: ["America/Sao_Paulo"]
        },
        {
          value: "-03:00$America/Argentina/La_Rioja$Buenos Aires",
          abbr: "AST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Buenos Aires",
          utc: [
            "America/Argentina/La_Rioja",
            "America/Argentina/Rio_Gallegos",
            "America/Argentina/Salta",
            "America/Argentina/San_Juan",
            "America/Argentina/San_Luis",
            "America/Argentina/Tucuman",
            "America/Argentina/Ushuaia",
            "America/Buenos_Aires",
            "America/Catamarca",
            "America/Cordoba",
            "America/Jujuy",
            "America/Mendoza"
          ]
        },
        {
          value: "-03:00$America/Araguaina$Cayenne, Fortaleza",
          abbr: "SEST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Cayenne, Fortaleza",
          utc: [
            "America/Araguaina",
            "America/Belem",
            "America/Cayenne",
            "America/Fortaleza",
            "America/Maceio",
            "America/Paramaribo",
            "America/Recife",
            "America/Santarem",
            "Antarctica/Rothera",
            "Atlantic/Stanley",
            "Etc/GMT+3"
          ]
        },
        {
          value: "-03:00$America/Godthab$Greenland",
          abbr: "GDT",
          offset: -3,
          isdst: true,
          text: "(UTC-03:00) Greenland",
          utc: ["America/Godthab"]
        },
        {
          value: "-03:00$America/Montevideo$Montevideo",
          abbr: "MST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Montevideo",
          utc: ["America/Montevideo"]
        },
        {
          value: "-03:00$America/Bahia$Salvador",
          abbr: "BST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Salvador",
          utc: ["America/Bahia"]
        },
        {
          value: "-02:00$America/Noronha$Coordinated Universal Time",
          abbr: "U",
          offset: -2,
          isdst: false,
          text: "(UTC-02:00) Coordinated Universal Time-02",
          utc: ["America/Noronha", "Atlantic/South_Georgia", "Etc/GMT+2"]
        },
        {
          value: "-00:00$America/Scoresbysund$Azores",
          abbr: "ADT",
          offset: 0,
          isdst: true,
          text: "(UTC-01:00) Azores",
          utc: ["America/Scoresbysund", "Atlantic/Azores"]
        },
        {
          value: "-01:00$Atlantic/Cape_Verde$Cape Verde Is",
          abbr: "CVST",
          offset: -1,
          isdst: false,
          text: "(UTC-01:00) Cape Verde Is.",
          utc: ["Atlantic/Cape_Verde", "Etc/GMT+1"]
        },
        {
          value:
            "+02:00$Arctic/Longyearbyen$Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
          abbr: "WEDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
          utc: [
            "Arctic/Longyearbyen",
            "Europe/Amsterdam",
            "Europe/Andorra",
            "Europe/Berlin",
            "Europe/Busingen",
            "Europe/Gibraltar",
            "Europe/Luxembourg",
            "Europe/Malta",
            "Europe/Monaco",
            "Europe/Oslo",
            "Europe/Rome",
            "Europe/San_Marino",
            "Europe/Stockholm",
            "Europe/Vaduz",
            "Europe/Vatican",
            "Europe/Vienna",
            "Europe/Zurich"
          ]
        },
        {
          value:
            "+02:00$Europe/Belgrade$Belgrade, Bratislava, Budapest, Ljubljana, Prague",
          abbr: "CEDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
          utc: [
            "Europe/Belgrade",
            "Europe/Bratislava",
            "Europe/Budapest",
            "Europe/Ljubljana",
            "Europe/Podgorica",
            "Europe/Prague",
            "Europe/Tirane"
          ]
        },
        {
          value: "+02:00$Africa/Ceuta$Brussels, Copenhagen, Madrid, Paris",
          abbr: "RDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
          utc: [
            "Africa/Ceuta",
            "Europe/Brussels",
            "Europe/Copenhagen",
            "Europe/Madrid",
            "Europe/Paris"
          ]
        },
        {
          value: "+02:00$Europe/Sarajevo$Sarajevo, Skopje, Warsaw, Zagreb",
          abbr: "CEDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
          utc: [
            "Europe/Sarajevo",
            "Europe/Skopje",
            "Europe/Warsaw",
            "Europe/Zagreb"
          ]
        },
        {
          value: "+01:00$Africa/Algiers$West Central Africa",
          abbr: "WCAST",
          offset: 1,
          isdst: false,
          text: "(UTC+01:00) West Central Africa",
          utc: [
            "Africa/Algiers",
            "Africa/Bangui",
            "Africa/Brazzaville",
            "Africa/Douala",
            "Africa/Kinshasa",
            "Africa/Lagos",
            "Africa/Libreville",
            "Africa/Luanda",
            "Africa/Malabo",
            "Africa/Ndjamena",
            "Africa/Niamey",
            "Africa/Porto-Novo",
            "Africa/Tunis",
            "Etc/GMT-1"
          ]
        },
        {
          value: "+01:00$Africa/Windhoek$Windhoek",
          abbr: "NST",
          offset: 1,
          isdst: false,
          text: "(UTC+01:00) Windhoek",
          utc: ["Africa/Windhoek"]
        },
        {
          value: "+03:00$Asia/Nicosia$Athens, Bucharest",
          abbr: "GDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Athens, Bucharest",
          utc: [
            "Asia/Nicosia",
            "Europe/Athens",
            "Europe/Bucharest",
            "Europe/Chisinau"
          ]
        },
        {
          value: "+03:00$Asia/Beirut$Beirut",
          abbr: "MEDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Beirut",
          utc: ["Asia/Beirut"]
        },
        {
          value: "+02:00$Africa/Cairo$Cairo",
          abbr: "EST",
          offset: 2,
          isdst: false,
          text: "(UTC+02:00) Cairo",
          utc: ["Africa/Cairo"]
        },
        {
          value: "+03:00$Asia/Damascus$Damascus",
          abbr: "SDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Damascus",
          utc: ["Asia/Damascus"]
        },
        {
          value: "+03:00$Asia/Nicosia$E. Europe",
          abbr: "EEDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) E. Europe",
          utc: [
            "Asia/Nicosia",
            "Europe/Athens",
            "Europe/Bucharest",
            "Europe/Chisinau",
            "Europe/Helsinki",
            "Europe/Kiev",
            "Europe/Mariehamn",
            "Europe/Nicosia",
            "Europe/Riga",
            "Europe/Sofia",
            "Europe/Tallinn",
            "Europe/Uzhgorod",
            "Europe/Vilnius",
            "Europe/Zaporozhye"
          ]
        },
        {
          value: "+02:00$Africa/Blantyre$Harare, Pretoria",
          abbr: "SAST",
          offset: 2,
          isdst: false,
          text: "(UTC+02:00) Harare, Pretoria",
          utc: [
            "Africa/Blantyre",
            "Africa/Bujumbura",
            "Africa/Gaborone",
            "Africa/Harare",
            "Africa/Johannesburg",
            "Africa/Kigali",
            "Africa/Lubumbashi",
            "Africa/Lusaka",
            "Africa/Maputo",
            "Africa/Maseru",
            "Africa/Mbabane",
            "Etc/GMT-2"
          ]
        },
        {
          value:
            "+03:00$Europe/Helsinki$Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
          abbr: "FDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
          utc: [
            "Europe/Helsinki",
            "Europe/Kiev",
            "Europe/Mariehamn",
            "Europe/Riga",
            "Europe/Sofia",
            "Europe/Tallinn",
            "Europe/Uzhgorod",
            "Europe/Vilnius",
            "Europe/Zaporozhye"
          ]
        },
        {
          value: "+03:00$Europe/Istanbul$Istanbul",
          abbr: "TDT",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Istanbul",
          utc: ["Europe/Istanbul"]
        },
        {
          value: "+03:00$Asia/Jerusalem$Jerusalem",
          abbr: "JDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Jerusalem",
          utc: ["Asia/Jerusalem"]
        },
        {
          value: "+02:00$Africa/Tripoli$Tripoli",
          abbr: "LST",
          offset: 2,
          isdst: false,
          text: "(UTC+02:00) Tripoli",
          utc: ["Africa/Tripoli"]
        },
        {
          value: "+03:00$Asia/Amman$Amman",
          abbr: "JST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Amman",
          utc: ["Asia/Amman"]
        },
        {
          value: "+03:00$Asia/Baghdad$Baghdad",
          abbr: "AST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Baghdad",
          utc: ["Asia/Baghdad"]
        },
        {
          value: "+03:00$Europe/Kaliningrad$Kaliningrad, Minsk",
          abbr: "KST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Kaliningrad, Minsk",
          utc: ["Europe/Kaliningrad", "Europe/Minsk"]
        },
        {
          value: "+03:00$Asia/Aden$Kuwait, Riyadh",
          abbr: "AST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Kuwait, Riyadh",
          utc: [
            "Asia/Aden",
            "Asia/Bahrain",
            "Asia/Kuwait",
            "Asia/Qatar",
            "Asia/Riyadh"
          ]
        },
        {
          value: "+03:00$Africa/Addis_Ababa$Nairobi",
          abbr: "EAST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Nairobi",
          utc: [
            "Africa/Addis_Ababa",
            "Africa/Asmera",
            "Africa/Dar_es_Salaam",
            "Africa/Djibouti",
            "Africa/Juba",
            "Africa/Kampala",
            "Africa/Khartoum",
            "Africa/Mogadishu",
            "Africa/Nairobi",
            "Antarctica/Syowa",
            "Etc/GMT-3",
            "Indian/Antananarivo",
            "Indian/Comoro",
            "Indian/Mayotte"
          ]
        },
        {
          value: "+03:00$Europe/Kirov$Moscow, St. Petersburg, Volgograd",
          abbr: "MSK",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
          utc: [
            "Europe/Kirov",
            "Europe/Moscow",
            "Europe/Simferopol",
            "Europe/Volgograd"
          ]
        },
        {
          value: "+04:00$Europe/Astrakhan$Samara, Ulyanovsk, Saratov",
          abbr: "SAMT",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
          utc: ["Europe/Astrakhan", "Europe/Samara", "Europe/Ulyanovsk"]
        },
        {
          value: "+04:30$Asia/Tehran$Tehran",
          abbr: "IDT",
          offset: 4.5,
          isdst: true,
          text: "(UTC+03:30) Tehran",
          utc: ["Asia/Tehran"]
        },
        {
          value: "+04:00$Asia/Dubai$Abu Dhabi, Muscat",
          abbr: "AST",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Abu Dhabi, Muscat",
          utc: ["Asia/Dubai", "Asia/Muscat", "Etc/GMT-4"]
        },
        {
          value: "+05:00$Asia/Baku$Baku",
          abbr: "ADT",
          offset: 5,
          isdst: true,
          text: "(UTC+04:00) Baku",
          utc: ["Asia/Baku"]
        },
        {
          value: "+04:00$Indian/Mahe$Port Louis",
          abbr: "MST",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Port Louis",
          utc: ["Indian/Mahe", "Indian/Mauritius", "Indian/Reunion"]
        },
        {
          value: "+04:00$Asia/Tbilisi$Tbilisi",
          abbr: "GET",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Tbilisi",
          utc: ["Asia/Tbilisi"]
        },
        {
          value: "+04:00$Asia/Yerevan$Yerevan",
          abbr: "CST",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Yerevan",
          utc: ["Asia/Yerevan"]
        },
        {
          value: "+04:30$Asia/Kabul$Kabul",
          abbr: "AST",
          offset: 4.5,
          isdst: false,
          text: "(UTC+04:30) Kabul",
          utc: ["Asia/Kabul"]
        },
        {
          value: "+05:00$Antarctica/Mawson$Ashgabat, Tashkent",
          abbr: "WAST",
          offset: 5,
          isdst: false,
          text: "(UTC+05:00) Ashgabat, Tashkent",
          utc: [
            "Antarctica/Mawson",
            "Asia/Aqtau",
            "Asia/Aqtobe",
            "Asia/Ashgabat",
            "Asia/Dushanbe",
            "Asia/Oral",
            "Asia/Samarkand",
            "Asia/Tashkent",
            "Etc/GMT-5",
            "Indian/Kerguelen",
            "Indian/Maldives"
          ]
        },
        {
          value: "+05:00$Asia/Yekaterinburg$Yekaterinburg",
          abbr: "YEKT",
          offset: 5,
          isdst: false,
          text: "(UTC+05:00) Yekaterinburg",
          utc: ["Asia/Yekaterinburg"]
        },
        {
          value: "+05:00$Asia/Karachi$Islamabad, Karachi",
          abbr: "PKT",
          offset: 5,
          isdst: false,
          text: "(UTC+05:00) Islamabad, Karachi",
          utc: ["Asia/Karachi"]
        },
        {
          value: "+05:30$Asia/Kolkata$Chennai, Kolkata, Mumbai, New Delhi",
          abbr: "IST",
          offset: 5.5,
          isdst: false,
          text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
          utc: ["Asia/Kolkata"]
        },
        {
          value: "+05:30$Asia/Colombo$Sri Jayawardenepura",
          abbr: "SLST",
          offset: 5.5,
          isdst: false,
          text: "(UTC+05:30) Sri Jayawardenepura",
          utc: ["Asia/Colombo"]
        },
        {
          value: "+05:45$Asia/Kathmandu$Kathmandu",
          abbr: "NST",
          offset: 5.75,
          isdst: false,
          text: "(UTC+05:45) Kathmandu",
          utc: ["Asia/Kathmandu"]
        },
        {
          value: "+06:00$Antarctica/Vostok$Astana",
          abbr: "CAST",
          offset: 6,
          isdst: false,
          text: "(UTC+06:00) Astana",
          utc: [
            "Antarctica/Vostok",
            "Asia/Almaty",
            "Asia/Bishkek",
            "Asia/Qyzylorda",
            "Asia/Urumqi",
            "Etc/GMT-6",
            "Indian/Chagos"
          ]
        },
        {
          value: "+06:00$Asia/Dhaka$Dhaka",
          abbr: "BST",
          offset: 6,
          isdst: false,
          text: "(UTC+06:00) Dhaka",
          utc: ["Asia/Dhaka", "Asia/Thimphu"]
        },
        {
          value: "+06:30$Asia/Rangoon$Yangon",
          abbr: "MST",
          offset: 6.5,
          isdst: false,
          text: "(UTC+06:30) Yangon (Rangoon)",
          utc: ["Asia/Rangoon", "Indian/Cocos"]
        },
        {
          value: "+07:00$Antarctica/Davis$Bangkok, Hanoi, Jakarta",
          abbr: "SAST",
          offset: 7,
          isdst: false,
          text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
          utc: [
            "Antarctica/Davis",
            "Asia/Bangkok",
            "Asia/Hovd",
            "Asia/Jakarta",
            "Asia/Phnom_Penh",
            "Asia/Pontianak",
            "Asia/Saigon",
            "Asia/Vientiane",
            "Etc/GMT-7",
            "Indian/Christmas"
          ]
        },
        {
          value: "+07:00$Asia/Novokuznetsk$Novosibirsk",
          abbr: "NCAST",
          offset: 7,
          isdst: false,
          text: "(UTC+07:00) Novosibirsk",
          utc: ["Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk"]
        },
        {
          value: "+08:00$Asia/Hong_Kong$Beijing, Chongqing, Hong Kong, Urumqi",
          abbr: "CST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
          utc: ["Asia/Hong_Kong", "Asia/Macau", "Asia/Shanghai"]
        },
        {
          value: "+08:00$Asia/Krasnoyarsk$Krasnoyarsk",
          abbr: "NAST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Krasnoyarsk",
          utc: ["Asia/Krasnoyarsk"]
        },
        {
          value: "+08:00$Asia/Brunei$Kuala Lumpur, Singapore",
          abbr: "MPST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Kuala Lumpur, Singapore",
          utc: [
            "Asia/Brunei",
            "Asia/Kuala_Lumpur",
            "Asia/Kuching",
            "Asia/Makassar",
            "Asia/Manila",
            "Asia/Singapore",
            "Etc/GMT-8"
          ]
        },
        {
          value: "+08:00$Antarctica/Casey$Perth",
          abbr: "WAST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Perth",
          utc: ["Antarctica/Casey", "Australia/Perth"]
        },
        {
          value: "+08:00$Asia/Taipei$Taipei",
          abbr: "TST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Taipei",
          utc: ["Asia/Taipei"]
        },
        {
          value: "+08:00$Asia/Choibalsan$Ulaanbaatar",
          abbr: "UST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Ulaanbaatar",
          utc: ["Asia/Choibalsan", "Asia/Ulaanbaatar"]
        },
        {
          value: "+08:00$Asia/Irkutsk$Irkutsk",
          abbr: "NAEST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Irkutsk",
          utc: ["Asia/Irkutsk"]
        },
        {
          value: "+09:00$Asia/Dili$Osaka, Sapporo, Tokyo",
          abbr: "JST",
          offset: 9,
          isdst: false,
          text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
          utc: [
            "Asia/Dili",
            "Asia/Jayapura",
            "Asia/Tokyo",
            "Etc/GMT-9",
            "Pacific/Palau"
          ]
        },
        {
          value: "+09:00$Asia/Pyongyang$Seoul",
          abbr: "KST",
          offset: 9,
          isdst: false,
          text: "(UTC+09:00) Seoul",
          utc: ["Asia/Pyongyang", "Asia/Seoul"]
        },
        {
          value: "+09:30$Australia/Adelaide$Adelaide",
          abbr: "CAST",
          offset: 9.5,
          isdst: false,
          text: "(UTC+09:30) Adelaide",
          utc: ["Australia/Adelaide", "Australia/Broken_Hill"]
        },
        {
          value: "+09:30$Australia/Darwin$Darwin",
          abbr: "ACST",
          offset: 9.5,
          isdst: false,
          text: "(UTC+09:30) Darwin",
          utc: ["Australia/Darwin"]
        },
        {
          value: "+10:00$Australia/Brisbane4Brisbane",
          abbr: "EAST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Brisbane",
          utc: ["Australia/Brisbane", "Australia/Lindeman"]
        },
        {
          value: "+10:00$Australia/Melbourne4Canberra, Melbourne, Sydney",
          abbr: "AEST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Canberra, Melbourne, Sydney",
          utc: ["Australia/Melbourne", "Australia/Sydney"]
        },
        {
          value: "+10:00$Antarctica/DumontDUrville$Guam, Port Moresby",
          abbr: "WPST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Guam, Port Moresby",
          utc: [
            "Antarctica/DumontDUrville",
            "Etc/GMT-10",
            "Pacific/Guam",
            "Pacific/Port_Moresby",
            "Pacific/Saipan",
            "Pacific/Truk"
          ]
        },
        {
          value: "+10:00$Australia/Currie$Hobart",
          abbr: "TST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Hobart",
          utc: ["Australia/Currie", "Australia/Hobart"]
        },
        {
          value: "+09:00$Asia/Chita$Yakutsk",
          abbr: "YST",
          offset: 9,
          isdst: false,
          text: "(UTC+09:00) Yakutsk",
          utc: ["Asia/Chita", "Asia/Khandyga", "Asia/Yakutsk"]
        },
        {
          value: "+11:00$Antarctica/Macquarie$Solomon Is., New Caledonia",
          abbr: "CPST",
          offset: 11,
          isdst: false,
          text: "(UTC+11:00) Solomon Is., New Caledonia",
          utc: [
            "Antarctica/Macquarie",
            "Etc/GMT-11",
            "Pacific/Efate",
            "Pacific/Guadalcanal",
            "Pacific/Kosrae",
            "Pacific/Noumea",
            "Pacific/Ponape"
          ]
        },
        {
          value: "+11:00$Asia/Sakhalin$Vladivostok",
          abbr: "VST",
          offset: 11,
          isdst: false,
          text: "(UTC+11:00) Vladivostok",
          utc: ["Asia/Sakhalin", "Asia/Ust-Nera", "Asia/Vladivostok"]
        },
        {
          value: "+12:00$Antarctica/McMurdo$Auckland, Wellington",
          abbr: "NZST",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Auckland, Wellington",
          utc: ["Antarctica/McMurdo", "Pacific/Auckland"]
        },
        {
          value: "+12:00$Etc/GMT-12$Coordinated Universal Time",
          abbr: "U",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Coordinated Universal Time+12",
          utc: [
            "Etc/GMT-12",
            "Pacific/Funafuti",
            "Pacific/Kwajalein",
            "Pacific/Majuro",
            "Pacific/Nauru",
            "Pacific/Tarawa",
            "Pacific/Wake",
            "Pacific/Wallis"
          ]
        },
        {
          value: "+12:00$Pacific/Fiji$Fiji",
          abbr: "FST",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Fiji",
          utc: ["Pacific/Fiji"]
        },
        {
          value: "+12:00$Asia/Anadyr$Magadan",
          abbr: "MST",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Magadan",
          utc: [
            "Asia/Anadyr",
            "Asia/Kamchatka",
            "Asia/Magadan",
            "Asia/Srednekolymsk"
          ]
        },
        {
          value: "+13:00$Asia/Kamchatka$Petropavlovsk-Kamchatsky - Old",
          abbr: "KDT",
          offset: 13,
          isdst: true,
          text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
          utc: ["Asia/Kamchatka"]
        },
        {
          value: "+13:00$Etc/GMT-13$Enderbury",
          abbr: "TST",
          offset: 13,
          isdst: false,
          text: "(UTC+13:00) Enderbury",
          utc: [
            "Etc/GMT-13",
            "Pacific/Enderbury",
            "Pacific/Fakaofo",
            "Pacific/Tongatapu"
          ]
        },
        {
          value: "+13:00$Pacific/Apia$Samoa",
          abbr: "SST",
          offset: 13,
          isdst: false,
          text: "(UTC+13:00) Samoa",
          utc: ["Pacific/Apia"]
        }
      ]
    };
  }

  mounted() {
    // Default dropdown value
    this.$data.stringItem = {
      value: "-12:00$Etc/GMT+12$International Date Line West",
      abbr: "DST",
      offset: -12,
      isdst: false,
      text: "(UTC-12:00) International Date Line West",
      utc: ["Etc/GMT+12"]
    };
    this.updateTime(this.$data.stringItem.value);
  }

  updateTime(timezone) {
    this.$emit("timeZoneChange", timezone);
  }
}
